exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions[data-v-6d5fcdca] {\n  width: 6%;\n}\n", ""]);

// exports
